export const ValidationError = ({ errorMessage = '' }) => (<div className='admin-panel__form-validation-error'>{errorMessage}</div>);
